import { render } from "./ContactDashboardCard.vue?vue&type=template&id=094dc1c6&scoped=true"
import script from "./ContactDashboardCard.vue?vue&type=script&lang=js"
export * from "./ContactDashboardCard.vue?vue&type=script&lang=js"

import "./ContactDashboardCard.vue?vue&type=style&index=0&id=094dc1c6&scoped=true&lang=css"

import exportComponent from "/Users/abayomi/Documents/dev/microservice-2/contact-mgt-app-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-094dc1c6"]])

export default __exports__